/* global modForm Modalytics */
import {
	showStepWithFirstError,
	focusOnFirstErrorOnCurrentStep,
	markFieldAsInvalid
} from '../../helpers';
/**
 * Handle API errors
 * @param {Object} response - API response
 */
export function processAPIResponseErrors(response) {

	response.invalidFields.forEach(function(name) {
		markFieldAsInvalid(modForm.opts.form.querySelector('input[name="' + name + '"]'));
		Modalytics.heap('track', ['Validation API Error | ' + name, {}]);
	});

	showStepWithFirstError();
	focusOnFirstErrorOnCurrentStep();
}
